module.exports = __webpack_public_path__ + "img/fcb.f9d4baaa.png";